// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"8caf92f8","132":"a1d21a14","243":"4f3f076a","438":"ef633899","488":"85b36aaf","508":"126676d6","861":"7708658f","942":"319e34b6"}[chunkId] + ".chunk.js";
};